import React from 'react';
import type { ReactNode } from 'react';
import type {
  StringifiedResponsiveColumnOptions,
  ResponsiveColumnOptions,
} from '@axiom/ui';
import {
  CondensedHeader,
  CondensedMedium,
  GridColumn,
  GridRow,
} from '@axiom/ui';

type ColumnWidth = StringifiedResponsiveColumnOptions | ResponsiveColumnOptions;

export type SubmissionDetailsRowProps = {
  label: ReactNode;
  labelName?: string;
  name: string;
  value: ReactNode;
  labelWidth: ColumnWidth;
  dataWidth: ColumnWidth;
};

export const SubmissionDetailsRow = ({
  label,
  labelName,
  name,
  value,
  labelWidth,
  dataWidth,
}: SubmissionDetailsRowProps) => (
  <GridRow gutterBottom="8px">
    <GridColumn
      name={`${name}_LABEL_COL`}
      largeScreenWidth={labelWidth}
      tabletWidth={labelWidth}
      mobileWidth={12}
    >
      <CondensedHeader name={labelName}>{label}</CondensedHeader>
    </GridColumn>
    <GridColumn
      name={`${name}_DATA_COL`}
      largeScreenWidth={dataWidth}
      tabletWidth={dataWidth}
      mobileWidth={12}
    >
      <CondensedMedium name={name}>{value}</CondensedMedium>
    </GridColumn>
  </GridRow>
);
